/* eslint-disable indent */
import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import i18n from '../../../../translations/i18n';
import { DateCell } from '../../../data-table';
import { AgentBadge } from '../../../AgentBadge';
import { Item } from '../../../../api/opportunitiesApi/interfaces';
import { StatusBadge } from './components/StatusBadge';

export const getColumns = (
  hideClientsColumn: boolean = false,
  hideContactsColumn: boolean = false
): GridColDef[] => [
  {
    field: 'title',
    headerName: i18n.t('entities:opportunityItem.title'),
    width: 300,
    hideable: false,
  },
  {
    field: 'stage',
    headerName: i18n.t('entities:opportunityItem.stage'),
    width: 225,
    valueGetter: (stage: Item['stage']) => stage?.name,
  },
  {
    field: 'product',
    headerName: i18n.t('entities:opportunityItem.product'),
    width: 250,
    valueGetter: (product: Item['product']) => product.name,
  },
  ...(!hideContactsColumn
    ? [
        {
          field: 'contact',
          headerName: i18n.t('entities:opportunityItem.contact'),
          width: 250,
          valueGetter: (contact: Item['contact']) =>
            `${contact.firstName} ${contact.lastName}`,
        },
      ]
    : []),
  ...(!hideClientsColumn
    ? [
        {
          field: 'client',
          headerName: i18n.t('entities:opportunityItem.client'),
          width: 250,
          valueGetter: (client: Item['client']) => client.name,
        },
      ]
    : []),
  {
    field: 'agent',
    headerName: i18n.t('entities:opportunityItem.agent'),
    width: 200,
    renderCell: (params) => {
      const row = params.row;

      return <AgentBadge agent={row.agent} />;
    },
  },
  {
    field: 'status',
    headerName: i18n.t('entities:opportunityItem.status'),
    width: 130,
    renderCell: (params) => {
      return (
        <StatusBadge
          label={i18n.t(
            `entities:opportunityItem.enums.status.${params.row.status}`
          )}
          status={params.row.status}
        />
      );
    },
  },
  {
    field: 'closedAt',
    headerName: i18n.t('entities:opportunityItem.closedAt'),
    filterable: false,
    minWidth: 190,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <DateCell date={row.closedAt} />;
    },
  },
  {
    field: 'createdAt',
    headerName: i18n.t('entities:common.createdAt'),
    filterable: false,
    minWidth: 190,
    flex: 1,
    renderCell: (params) => {
      const row = params.row;

      return <DateCell date={row.createdAt} />;
    },
  },
];
